/**
 * Simple memoization utility for date formatting performance
 * Caches function results based on arguments to avoid repeated calculations
 */

type CacheableFunction = (...args: unknown[]) => unknown

export const memoize = (fn: CacheableFunction, maxSize: number = 100): CacheableFunction => {
  const cache = new Map<string, unknown>()

  return (...args: unknown[]): unknown => {
    // Create cache key from arguments
    const key = JSON.stringify(args)

    // Return cached result if available
    if (cache.has(key)) {
      return cache.get(key)
    }

    // Calculate result and cache it
    const result = fn(...args)

    // Maintain cache size limit (LRU-like behavior)
    if (cache.size >= maxSize) {
      const firstKey = cache.keys().next().value
      cache.delete(firstKey)
    }

    cache.set(key, result)
    return result
  }
}
